import Vue from 'vue'
import Vuex from 'vuex'
import i18n from './i18n'

import * as MUTATION from './const.mutations'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loaded: true,
    settings: null,
    menuOpened: null,
    searchQuery: null,
    isSearchOpen: false,
    fullscreenImgViewerOptions: null,
    isPageTransitioning: false,
    isSample: true,
    viewportSize: {
      width: 0,
      height: 0
    },
    searchOptions: null,
    nbItemDisplay: 0,
    audioPlayerState: {
      podcast: false,
      paragraph: false
    },
    searchListType: true
  },
  mutations: {
    [MUTATION.LOADED] (state, settings) {
      state.loaded = true
      state.settings = settings
    },
    [MUTATION.SET_MENU_OPEN] (state, isOpen) {
      state.menuOpened = isOpen
    },
    [MUTATION.IS_SAMPLE] (state, value) {
      state.isSample = value
    },
    [MUTATION.SET_SEARCH_QUERY] (state, query) {
      state.searchQuery = query
    },
    [MUTATION.SET_SEARCH_OPEN] (state, open) {
      state.isSearchOpen = open
    },
    [MUTATION.SET_SEARCH_OPTIONS] (state, options) {
      state.searchOptions = options
    },
    [MUTATION.SET_FULLSCREEN_IMG_VIEWER_OPTIONS] (state, options) {
      const defaultOptions = {
        src: '',
        thumbEl: null
      }
      if (options) {
        state.fullscreenImgViewerOptions = Object.assign({}, defaultOptions, options)
      } else {
        state.fullscreenImgViewerOptions = null
      }
    },
    [MUTATION.SET_PAGE_TRANSITIONING] (state, isTransitioning) {
      state.isPageTransitioning = isTransitioning
    },
    [MUTATION.UPDATE_VIEWPORT_SIZE] (state) {
      state.viewportSize = {
        width: window.innerWidth,
        height: window.innerHeight
      }
    },
    [MUTATION.UPDATE_NUMBER_ITEM_DISPLAY] (state, number) {
      state.nbItemDisplay = number
    },
    [MUTATION.UPDATE_AUDIO_PLAYER_STATE] (state, options) {
      state.audioPlayerState[options.name] = options.data
    },
    [MUTATION.SET_LIST_TYPE] (state, listType) {
      state.searchListType = listType
    }
  },
  actions: {
    loaded: ({ commit }, settings) => commit(MUTATION.LOADED, settings),
    setIsSample: ({ commit }, value) => commit(MUTATION.IS_SAMPLE, value),
    setMenuOpen: ({ commit }, isOpen) => commit(MUTATION.SET_MENU_OPEN, isOpen),
    setFullscreenImgOptions: ({ commit }, options) => commit(MUTATION.SET_FULLSCREEN_IMG_VIEWER_OPTIONS, options),
    setSearchQuery: ({ commit }, query) => {
      commit(MUTATION.SET_SEARCH_QUERY, query)
    },
    setSearchOpen: ({ commit }, open) => {
      commit(MUTATION.SET_SEARCH_OPEN, open)
    },
    setSearchOptions: ({ commit }, options) => {
      commit(MUTATION.SET_SEARCH_OPTIONS, options)
    },
    setIsPageTransitioning: ({ commit }, isTransitioning) => commit(MUTATION.SET_PAGE_TRANSITIONING, isTransitioning),
    updateViewportSize: ({ commit }) => commit(MUTATION.UPDATE_VIEWPORT_SIZE),
    updateNbItemDisplay: ({ commit }, number) => commit(MUTATION.UPDATE_NUMBER_ITEM_DISPLAY, number),
    updateAudioPlayerState: ({ commit }, options) => commit(MUTATION.UPDATE_AUDIO_PLAYER_STATE, options),
    setSearchListType: ({ commit }, listType) => commit(MUTATION.SET_LIST_TYPE, listType)
  },
  getters: {
    settings (state) {
      return state.settings
    },
    isSampled (state) {
      return state.isSample
    },
    menuOpened (state) {
      return state.menuOpened
    },
    isSearchOpened (state) {
      return state.isSearchOpen
    },
    fullscreenImgViewerOptions (state) {
      return state.fullscreenImgViewerOptions
    },
    searchOptions (state) {
      return state.searchOptions
    },
    searchQuery (state) {
      return state.searchQuery
    },
    isPageTransitioning (state) {
      return state.isPageTransitioning
    },
    viewportSize (state) {
      return state.viewportSize
    },
    nbItemDisplay (state) {
      return state.nbItemDisplay
    },
    audioPlayerStateParagraph (state) {
      return state.audioPlayerState.paragraph
    },
    audioPlayerStatePodcast (state) {
      return state.audioPlayerState.podcast
    },
    searchListType (state) {
      return state.searchListType
    }
  }
})
